import { render, staticRenderFns } from "./AddShortCourses.vue?vue&type=template&id=4ab9739a&"
import script from "./AddShortCourses.vue?vue&type=script&lang=js&"
export * from "./AddShortCourses.vue?vue&type=script&lang=js&"
import style0 from "./AddShortCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports